// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17fhr","label":"styles_label__1iLWZ"};